import Vue from 'vue';
import ModultypenService from './modultypen.service';
import _ from 'lodash';

const getDefaultItem = () => ({});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
});

const modultypen = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await ModultypenService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await ModultypenService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await ModultypenService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { data } = await ModultypenService.query(params);
            context.commit('updateList', _.sortBy(data));
            return data;
        },
        async delete(context, slug) {
            await ModultypenService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default modultypen;
